module.exports = __webpack_public_path__ + "img/aspirant.77b775af.png";